var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1Logo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2cbeff;}.cls-2{fill:#ff7171;}.cls-3{fill:#00ff67;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M644,523.65s1.5-24.26-29.37-42.88L560.34,450l10.55,46.14L537,504.25l9.78,6.47-38.42,78.51,9.78,41.28,42.21-81s22.59,32.38,55,21.05C615.33,570.61,645.47,560.89,644,523.65Zm-45.21,20.23c-10.38,0-18.82-9-18.82-20.23s8.44-20.22,18.82-20.22,18.83,9.07,18.83,20.22S609.18,543.88,598.76,543.88Z",
    transform: "translate(-450 -450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M472.47,636.36s-20.75,9.72-22,47.73L450,750l33.3-31.26,22.28,28.62.85-12.31,82.57.59,29.63-28.29-86.31-3.09s16.39-36.43-7.86-62.14C524.46,642.12,502.57,617.82,472.47,636.36ZM510,670.21c4.77,9.91,1.18,22.11-8.08,27.26s-20.6,1.23-25.37-8.68-1.15-22.13,8.07-27.26S505.18,660.27,510,670.21Z",
    transform: "translate(-450 -450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M649.68,740.71s19.08,13.08,49.12-7.05L750,697.34,707.27,685.1,717,649.26l-10,6.11-45.61-73.94L623,570.79l45.77,78.68s-37.29,5.71-43.62,41.68C625.12,691.15,618.56,724.21,649.68,740.71Zm5.22-52.31c5-9.79,16.43-13.39,25.57-8s12.45,17.68,7.45,27.46-16.45,13.37-25.56,8S649.89,698.21,654.9,688.4Z",
    transform: "translate(-450 -450)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Logo);
export default __webpack_public_path__ + "static/media/1logo.2dc3dc31.svg";
export { ForwardRef as ReactComponent };